import { makeAutoObservable } from "mobx";

const DEFAULT_RESULT = {
  scope: "all",
  year: null,
  unit: "tCO2e",
  rootOrganization: null,
  headline: null,
  rows: [],
  warnings: [],
};

class DashboardEmissionsBreakdownStore {
  open = false;
  scope = "all";
  selectedOrgIds = [];
  result = { ...DEFAULT_RESULT };
  loading = false;
  hasLoadedOnce = false;
  error = "";
  requestSeq = 0;

  constructor() {
    makeAutoObservable(this);
  }

  nextRequestSeq = () => {
    this.requestSeq += 1;
    return this.requestSeq;
  };

  isStaleSeq = (seq) => seq !== this.requestSeq;

  openForScope = (scope) => {
    this.open = true;
    this.scope = scope ?? "all";
    this.selectedOrgIds = [];
    this.result = { ...DEFAULT_RESULT, scope: scope ?? "all" };
    this.loading = false;
    this.hasLoadedOnce = false;
    this.error = "";
  };

  close = () => {
    this.open = false;
    this.loading = false;
    this.error = "";
    this.selectedOrgIds = [];
  };

  setSelectedOrgIds = (ids) => {
    this.selectedOrgIds = Array.isArray(ids) ? [...ids] : [];
  };

  setResult = (result) => {
    this.result = {
      ...DEFAULT_RESULT,
      ...(result || {}),
      rows: Array.isArray(result?.rows) ? result.rows : [],
      warnings: Array.isArray(result?.warnings) ? result.warnings : [],
    };
    this.hasLoadedOnce = true;
  };

  setLoading = (value) => {
    this.loading = Boolean(value);
  };

  setError = (message) => {
    this.error = message || "";
  };
}

export const dashboardEmissionsBreakdownStore =
  new DashboardEmissionsBreakdownStore();
